const LAYER_SPEED = 400;

export {
	LAYER_SPEED
};



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/common-config.js